export default __webpack_public_path__ + "static/media/gallery - spells_00.8c715750.jpg";